var map = {
	"./AdminOrders.vue": 44030,
	"./Cart.vue": 52802,
	"./CustomerCare.vue": 31227,
	"./Deliveries.vue": 38237,
	"./EditCategory.vue": 47778,
	"./EditCostCentre.vue": 54535,
	"./EditCustomerLocation.vue": 15956,
	"./EditDelivery.vue": 43139,
	"./EditDeliveryDate.vue": 90625,
	"./EditDivision.vue": 31726,
	"./EditEmail.vue": 70433,
	"./EditEmailLog.vue": 13897,
	"./EditPickingList.vue": 94594,
	"./EditPickingListItem.vue": 73453,
	"./EditPreferredDeliveryAddress.vue": 9486,
	"./EditPurchaseLimit.vue": 43833,
	"./EditQuote.vue": 9884,
	"./EditRestaurantAdmin.vue": 40076,
	"./EditSoftSaleStockItem.vue": 45408,
	"./EditStockItem.vue": 99117,
	"./EditSupplier.vue": 78180,
	"./Favourites.vue": 59494,
	"./ListCategory.vue": 64854,
	"./ListCostCentre.vue": 58670,
	"./ListCustomerLocation.vue": 64429,
	"./ListDelivery.vue": 71156,
	"./ListDeliveryDate.vue": 8382,
	"./ListDivision.vue": 49586,
	"./ListEmail.vue": 97496,
	"./ListOrder.vue": 4874,
	"./ListPickingList.vue": 36954,
	"./ListPickingListItem.vue": 24408,
	"./ListPreferredDeliveryAddress.vue": 74416,
	"./ListPurchaseLimit.vue": 26154,
	"./ListQuotes.vue": 37607,
	"./ListRestaurantAdmin.vue": 48959,
	"./ListStockItem.vue": 53808,
	"./ListSupplier.vue": 6683,
	"./OrderConfirmed.vue": 16919,
	"./Orders.vue": 3508,
	"./PickingList.vue": 21814,
	"./ProductRequest.vue": 71271,
	"./Quote.vue": 65595,
	"./SalesDashboard.vue": 65405,
	"./ShopCategories.vue": 78596,
	"./ShopCategoriesHorizontal.vue": 72488,
	"./ShopHome.vue": 32838,
	"./ShopSearch.vue": 27298,
	"./ShopStockItem.vue": 87149,
	"./ShopStockItemByCategory.vue": 45047,
	"./ShopStockItems.vue": 13258,
	"./StockItemDetail.vue": 29080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47780;